// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 524 ? "app" : chunkId) + "." + {"213":"1efef471","423":"6981a911","453":"29df7b39","524":"8d391578"}[chunkId] + ".chunk.js";
};